import { render, staticRenderFns } from "./EditTeacherProfile.vue?vue&type=template&id=3705406b&scoped=true&"
import script from "./EditTeacherProfile.vue?vue&type=script&lang=js&"
export * from "./EditTeacherProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditTeacherProfile.vue?vue&type=style&index=0&id=3705406b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3705406b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardTitle,VCol,VContainer,VIcon,VRow})
